"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionSchemaType = void 0;
/**
 * 多维表数据类型
 */
var CollectionSchemaType;
(function (CollectionSchemaType) {
    CollectionSchemaType["TITLE"] = "title";
    CollectionSchemaType["TEXT"] = "text";
    CollectionSchemaType["NUMBER"] = "number";
    CollectionSchemaType["SELECT"] = "select";
    CollectionSchemaType["MULTI_SELECT"] = "multi_select";
    CollectionSchemaType["DATE"] = "date";
    CollectionSchemaType["CHECKBOX"] = "checkbox";
    CollectionSchemaType["CREATED_AT"] = "created_at";
    CollectionSchemaType["UPDATED_AT"] = "updated_at";
    CollectionSchemaType["CREATED_BY"] = "created_by";
    CollectionSchemaType["UPDATED_BY"] = "updated_by";
    CollectionSchemaType["PHONE"] = "phone";
    CollectionSchemaType["EMAIL"] = "email";
    CollectionSchemaType["URL"] = "url";
    CollectionSchemaType["FILE"] = "file";
    CollectionSchemaType["PERSON"] = "person";
    CollectionSchemaType["FORMULA"] = "formula";
    CollectionSchemaType["RELATION"] = "relation";
    CollectionSchemaType["ROLLUP"] = "rollup";
    CollectionSchemaType["ID_NUMBER"] = "id_number";
})(CollectionSchemaType = exports.CollectionSchemaType || (exports.CollectionSchemaType = {}));
